module.exports = __webpack_public_path__ + "static/media/copy_blue.c2ec8136.svg";